import { Navigate, Route, Routes } from "react-router-dom";

import {
  S2_DASHBOARD_ALIAS_ROUTES,
  S2_DASHBOARD_ROUTES,
  S2DashboardProvider,
} from "@/features/S2Dashboard";

import AnalyticsPage from "./AnalyticsPage";
import AuditPage from "./AuditPage";
import CapitalAccountPage from "./CapitalAccountPage";
import FundOverviewPage from "./FundOverviewPage";
import PortfolioPage from "./PortfolioPage";
import S2DataUpload from "./S2DataUpload/main";

function S2Page({ children }: { children: React.ReactNode }) {
  return (
    <S2DashboardProvider>
      <main className="min-h-0 flex-1 overflow-auto p-5 bg-gray-50">
        {children}
      </main>
    </S2DashboardProvider>
  );
}

export default function S2Routes() {
  return (
    <Routes>
      <Route
        path={`${S2_DASHBOARD_ROUTES.dataUpload}/*`}
        element={<S2DataUpload />}
      />
      <Route
        path={`${S2_DASHBOARD_ALIAS_ROUTES.dataUpload}/*`}
        element={
          <Navigate to={`../${S2_DASHBOARD_ROUTES.dataUpload}`} replace />
        }
      />
      <Route
        path={S2_DASHBOARD_ALIAS_ROUTES.fundOverview}
        element={
          <Navigate to={`../${S2_DASHBOARD_ROUTES.fundOverview}`} replace />
        }
      />
      <Route
        path={S2_DASHBOARD_ALIAS_ROUTES.capitalAccount}
        element={
          <Navigate to={`../${S2_DASHBOARD_ROUTES.capitalAccount}`} replace />
        }
      />
      <Route
        path={S2_DASHBOARD_ALIAS_ROUTES.portfolio}
        element={
          <Navigate to={`../${S2_DASHBOARD_ROUTES.portfolio}`} replace />
        }
      />
      <Route
        path={S2_DASHBOARD_ALIAS_ROUTES.analytics}
        element={
          <Navigate to={`../${S2_DASHBOARD_ROUTES.analytics}`} replace />
        }
      />
      <Route
        path={S2_DASHBOARD_ALIAS_ROUTES.audit}
        element={<Navigate to={`../${S2_DASHBOARD_ROUTES.audit}`} replace />}
      />

      <Route
        path={S2_DASHBOARD_ROUTES.fundOverview}
        element={
          <S2Page>
            <FundOverviewPage />
          </S2Page>
        }
      />
      <Route
        path={S2_DASHBOARD_ROUTES.capitalAccount}
        element={
          <S2Page>
            <CapitalAccountPage />
          </S2Page>
        }
      />
      <Route
        path={S2_DASHBOARD_ROUTES.portfolio}
        element={
          <S2Page>
            <PortfolioPage />
          </S2Page>
        }
      />
      <Route
        path={S2_DASHBOARD_ROUTES.analytics}
        element={
          <S2Page>
            <AnalyticsPage />
          </S2Page>
        }
      />
      <Route
        path={S2_DASHBOARD_ROUTES.audit}
        element={
          <S2Page>
            <AuditPage />
          </S2Page>
        }
      />
      <Route
        index
        element={<Navigate to={S2_DASHBOARD_ROUTES.fundOverview} replace />}
      />
      <Route
        path="*"
        element={<Navigate to={S2_DASHBOARD_ROUTES.fundOverview} replace />}
      />
    </Routes>
  );
}
